import { IPerson } from './../../../interfaces/models';
import { Injectable } from '@angular/core';
import { DataService } from 'src/app/services/http/data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PersonService extends DataService {

  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  create(data: IPerson) {
    return this.post(data, '?ctrl=person&action=creer');
  }
  supprimer(id: any) {
    return this.delete(id, '?ctrl=person&action=supprimer');
  }

  updateDepot(data: IPerson) {
    return this.update(data, '?ctrl=person&action=modifier');
  }
}
